const resource = '/admin/v1/app-user-campaigns';

export default $axios => ({
  index(payload = {}) {
    return $axios.get(`${resource}`, {params: payload});
  },

  show(id) {
    return $axios.get(`${resource}/${id}`);
  }
});
